<script setup lang="ts">
import {
  inject,
  onMounted,
  type Ref,
  ref,
} from 'vue';
import { sendClickAnalytics } from '../../../../utils';
import tags from '../../../../utils/globalTags';
import { apiCall } from '../../../../api/services/apiCalls';
import { HelpTopicCard } from '../../../../api/types/HelpTopicCard';
import CollapsedCategory from './CollapsedCategory.vue';
import ExpandedCategory from './ExpandedCategory.vue';
import { centerState } from '../../models/types/ColumnsCenterState';

const mainArray: Ref<HelpTopicCard[]> = ref([]);
const activeCenter = ref('');
const { setState } = inject<centerState>('centerState');

const helpCardsMetricHandler = async (adobeName?: string) => {
  const clickData = {
    pageName: '',
    linkName: `${tags.HELP_CENTER_HOMEPAGE}_${adobeName.split(' ').join('_')}`,
  };
  sendClickAnalytics(clickData);
};

const resetContent = async () => {
  mainArray.value = await apiCall('default', 'help-topics');
};

const handleClickActive = () => {
  activeCenter.value = '';
};

const handleClick = (helpCenter: { helpCenterName?: string; helpCenterId?: string; isBackButton?: string; adobeName?: string }) => {
  const {
    helpCenterName, isBackButton, adobeName,
  } = helpCenter;
  if (isBackButton) {
    resetContent();
    return;
  }
  activeCenter.value = helpCenterName;
  setState({ helpCenter: adobeName });
  helpCardsMetricHandler(adobeName);
};

onMounted(async () => {
  if (!mainArray.value.length) {
    resetContent();
  }
});
</script>

<template>
  <div class="help-centers-u__column help-centers-u__column-primary">
    <div
      v-for="(helpCenter) in mainArray"
      class="help-centers-u__cards-wrap"
      :key="helpCenter.adobeName"
    >
      <ExpandedCategory
        v-if="activeCenter === helpCenter.helpCenterName"
        :helpCenter="helpCenter"
        :handleClick="handleClickActive"
      />
      <CollapsedCategory
        v-if="activeCenter === ''"
        :helpCenter="helpCenter"
        @click="handleClick(helpCenter)"
      />
    </div>
  </div>
</template>

<style lang="scss">
  @import 'src/main/style/helpCenterColumnsUpdate.scss';
</style>
